import FeatureGates from '@atlaskit/feature-gate-js-client';

// ALL FEATURE GATES SHOULD BE CALLBACKS

/**
 * UPP-UI-FEATURE-GATE-TEST
 * @link https://switcheroo.atlassian.com/ui/gates/ab5c3a4c-7985-4532-bd93-cb0ae3160a25/key/upp-ui-feature-gate-test
 * @description This feature gate is used to test the feature gate functionality in UPP UI
 * @returns true if the user should see the feature
 */
export const uppUiFeatureGateTestIsActive = () =>
  FeatureGates.checkGate('upp-ui-feature-gate-test') ?? false;

/**
 * PRODUCT-ID-TO-NODE-ID-CHANGE
 * @link https://switcheroo.atlassian.com/ui/gates/02faeae7-dda3-4d18-9ab7-bbbbfc795ce2/key/product-id-to-node-id-change
 * @description This feature gate is used to test the feature gate functionality in UPP UI
 * @returns true if the user should see the feature
 */
export const productIdToNodeIdChangeIsActive = () => {
  const { REACT_APP_USE_MOCK_NETWORK_HANDLER } = process.env;

  if (REACT_APP_USE_MOCK_NETWORK_HANDLER === 'true') {
    return true;
  }

  return FeatureGates.checkGate('product-id-to-node-id-change') ?? false;
};

/**
 * UPP-UI-UNIFIED-ACCOUNT
 * @link https://switcheroo.atlassian.com/ui/gates/b23f13bc-12fb-4a29-94d7-052909fa5d6e/key/upp-ui-feature-unified-account
 * @description This feature gate is used to test the feature gate functionality in UPP UI
 * @returns true if the user should see the feature
 */
export const uppUiFeatureUnifiedAccountIsActive = () =>
  FeatureGates.checkGate('upp-ui-feature-unified-account') ?? false;

/**
 * Champions
 * @link https://switcheroo.atlassian.com/ui/gates/1c176618-c5ca-4dd5-849a-17e19a2d59e9/key/community-champions-page
 *
 */
export const championsIsActive = () =>
  FeatureGates.checkGate('community-champions-page') ?? false;

/**
 * Account Switcher
 * @link https://switcheroo.atlassian.com/ui/gates/7273b874-7130-439f-9f4e-c5c26b9fedca/key/community-account-switcher
 */
export const accountSwitcherIsActive = () =>
  FeatureGates.checkGate('community-account-switcher') ?? false;

/**
 * Give Recognition
 * @link https://switcheroo.atlassian.com/ui/gates/efb253bc-1b9c-4744-bd42-c474528a1f6c/key/community-give-recognition-upp
 */
export const giveRecognitionIsActive = () =>
  FeatureGates.checkGate('community-give-recognition-upp') ?? false;

/**
 * New Navigation
 * @link https://switcheroo.atlassian.com/ui/gates/9912bd84-cf3a-4586-88b2-e61641977351/key/community_new_top_navigation
 * @description This feature gate controls the new navigation feature
 * @returns true if the user should see the new navigation feature
 */
export const newNavigationIsActive = () =>
  FeatureGates.checkGate('community_new_top_navigation') ?? false;
